import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';

const { colors, spacing, typography, breakpoints } = THEME;

// --custom-* vars come from the page theme the API injects on public survey pages; the fallbacks
// keep the Levitate blue everywhere else, including the admin collect-payment page.
const headerBackground = `var(--custom-primary-button-bg, ${colors.primary.main})`;
const headerForeground = `var(--custom-primary-button-text, ${colors.primary.contrastText})`;

export const s = StyleSheet.create({
	pageContainer: {
		position: 'fixed',
		left: 0,
		right: 0,
		bottom: 0,
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: colors.background.main,
		zIndex: 10,
		overflow: 'hidden',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
		flexShrink: 0,
		backgroundColor: headerBackground,
		color: headerForeground,
		padding: `${spacing.sm}px ${spacing.lg}px`,
		minHeight: 50,
	},
	scrollArea: {
		flex: 1,
		overflowX: 'hidden',
		overflowY: 'auto',
		padding: `${spacing.xl}px 0`,
		[`@media (max-width: ${breakpoints.md}px)`]: {
			padding: 0,
		},
	},
	headerTitle: {
		fontSize: typography.fontSizes.lg,
		fontWeight: typography.fontWeights.bold,
		margin: 0,
		color: headerForeground,
	},
	closeButton: {
		position: 'absolute',
		right: spacing.lg,
		top: '50%',
		transform: 'translateY(-50%)',
		padding: '0 !important',
		color: `${headerForeground} !important`,
	},
	contentContainer: {
		display: 'flex',
		flexDirection: 'row',
		width: '80%',
		maxWidth: 1400,
		margin: '0 auto',
		gap: spacing.lg,
		[`@media (max-width: ${breakpoints.lg}px)`]: {
			width: '92%',
		},
		[`@media (max-width: ${breakpoints.md}px)`]: {
			flexDirection: 'column',
			width: '100%',
			margin: 0,
			gap: 0,
		},
	},
	summaryColumn: {
		flex: 1,
		padding: 36,
		backgroundColor: colors.background.light,
		borderRadius: 8,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
		[`@media (max-width: ${breakpoints.md}px)`]: {
			padding: spacing.lg,
			borderRadius: 0,
		},
	},
	paymentColumn: {
		flex: 1,
		padding: 36,
		backgroundColor: colors.background.light,
		borderRadius: 8,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
		overflowX: 'hidden',
		minWidth: 0,
		[`@media (max-width: ${breakpoints.md}px)`]: {
			padding: spacing.lg,
			borderRadius: 0,
		},
	},
});
